import { ONE_MINUTE_MS, Timecode } from '@ftr/contracts/type/shared'
import { LocalDateTime } from '@js-joda/core'
import { AbstractBuilder } from './AbstractBuilder'

export class TimecodeBuilder extends AbstractBuilder<Timecode> {
  constructor() {
    super(new Timecode(LocalDateTime.now(), 5 * ONE_MINUTE_MS))
  }
}
